"use strict";
// https://github.com/NoHomey/bind-decorator/blob/master/src/index.ts
Object.defineProperty(exports, "__esModule", { value: true });
var constants;
(function (constants) {
    constants.typeOfFunction = 'function';
    constants.boolTrue = true;
})(constants || (constants = {}));
function bind(_target, propertyKey, descriptor) {
    return {
        configurable: constants.boolTrue,
        get: function () {
            var bound = descriptor.value.bind(this);
            Object.defineProperty(this, propertyKey, {
                value: bound,
                configurable: constants.boolTrue,
                writable: constants.boolTrue,
            });
            return bound;
        },
    };
}
exports.default = bind;
//# sourceMappingURL=bind.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/bind.js
// module id = DEcC
// module chunks = 20 21 22